<div>
  <div class="background"></div>
  <div class="modal-wrapper" [ngClass]="{'big-modal-wrapper': isModaleGrande, 'small-modal-wrapper': !isModaleGrande}">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </div>
</div>
